import type { ReactNode } from 'react'
import { useParams } from 'react-router-dom'

import { orgRoutes, settingsRoutes } from '@/routes/org-routes.const'

import { MembersContentSection } from './members-content.view'
import { MembersDialogsSection } from './members-dialogs.view'
import { useMembersSettings } from './use-members-settings.hook'
import { useMembersViewState } from './use-members-view-state.hook'

export const MembersSettingsView: React.FC = (): ReactNode => {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  const settings = useMembersSettings()
  const viewState = useMembersViewState({
    memberList: settings.memberList,
    invitationList: settings.invitationList,
  })

  return (
    <div className="members-settings-view space-y-6">
      <MembersContentSection
        settings={settings}
        subscriptionHref={`/${orgSlug}/${orgRoutes.settings}/${settingsRoutes.subscription}`}
        onRoleChange={viewState.handleRoleChange(settings)}
        onRemoveMember={viewState.setMemberToRemoveId}
        onRevokeInvitation={viewState.setInvitationToRevokeId}
        onInviteClick={() => viewState.setIsInviteDialogOpen(true)}
        onLeaveClick={() => viewState.setIsLeaveDialogOpen(true)}
      />
      <MembersDialogsSection
        isInviteDialogOpen={viewState.isInviteDialogOpen}
        onInviteDialogOpenChange={viewState.setIsInviteDialogOpen}
        onInvite={viewState.handleInvite(settings)}
        isInviting={settings.isInviting}
        memberToRemove={viewState.memberToRemove}
        onRemoveDialogClose={() => viewState.setMemberToRemoveId(null)}
        onRemoveConfirm={viewState.handleRemoveConfirm(settings)}
        invitationToRevoke={viewState.invitationToRevoke}
        onRevokeDialogClose={() => viewState.setInvitationToRevokeId(null)}
        onRevokeConfirm={viewState.handleRevokeConfirm(settings)}
        isLeaveDialogOpen={viewState.isLeaveDialogOpen}
        onLeaveDialogOpenChange={viewState.setIsLeaveDialogOpen}
        onLeaveConfirm={viewState.handleLeaveConfirm(settings)}
      />
    </div>
  )
}

MembersSettingsView.displayName = 'MembersSettingsView'
